/* import __COLOCATED_TEMPLATE__ from './selected-posts.hbs'; */
import Component from "@ember/component";

export default class SelectedPosts extends Component {}
